import React from 'react'

import { Testable } from '@cred/react-testable'
import { Disclosure } from '@cred/react-disclosures-sdk'

import styles from './styles.module.scss'

const Disclosures = () => {
  const dateToday = new Date()
  const dateTodayFormatted = `${
    dateToday.getMonth() + 1
  }/${dateToday.getDate()}/${dateToday.getFullYear()}`

  return (
    <div className={styles.disclosureContainer}>
      <Testable className={styles.disclosure} testId="disclosure-content">
        <div className={`${styles.disclosureContent} neutral500 bodySmall`}>
          <Disclosure
            required={false}
            slug="partners-widgets.mortgage-combined.general-info.disclosure"
            variables={{ dateTodayFormatted }}
          />
          <Disclosure required={false} slug="partners-widgets.mortgage-combined.fees.disclosure" />
        </div>
        <div className="neutral500 bodySmall">
          <Disclosure required={false} slug="mortgages.rates-page.nmls-number" />
        </div>
      </Testable>
    </div>
  )
}

export default Disclosures
